<script></script>

<template>
    <slot></slot>
</template>
